import styled from 'styled-components';
import { Layout } from '~/contexts/Data';
import { BreakpointValues, useBreakpointValue } from '~/hooks/useBreakpoint';
import { media } from '~/styles/media';

export const numberOfColumns: BreakpointValues = {
  mobile: 1,
  tablet: 2,
  desktop: 4,
  tv: 5,
  fallback: 8,
};

export const useNumberOfColumns = () => useBreakpointValue(numberOfColumns);

type Props = {
  $layout: Layout;
};

const TokenGrid = styled.div<Props>`
  width: 100%;
  display: grid;
  grid-gap: ${({ $layout }) => ($layout === 'gallery' ? 1 : 30)}px;
  grid-template-columns: repeat(${numberOfColumns.fallback}, minmax(0, 1fr));
  ${media.tv`
    grid-template-columns: repeat(${numberOfColumns.tv}, minmax(0, 1fr));
  `};
  ${media.desktop`
    grid-template-columns: repeat(${numberOfColumns.desktop}, minmax(0, 1fr));
  `};
  ${media.tablet`
    grid-template-columns: repeat(${numberOfColumns.tablet}, minmax(0, 1fr));
  `};
  ${media.mobile`
    grid-template-columns: repeat(${numberOfColumns.mobile}, minmax(0, 1fr));
    grid-gap: ${({ $layout }: Props) => ($layout === 'gallery' ? 1 : 50)}px;
  `};
`;

export default TokenGrid;
